import { FacilityCategory } from '../entites/FacilityInfo'

export const getChildCategoryLabel = (category: FacilityCategory): string => {
  if (category === 'both_child') return '病児・病後児'
  else if (category === 'sick_child') return '病児'
  else if (category === 'after_sick_child') return '病後児'
  return ''
}
